var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payPay-content"},[_c('DownloadApp',{staticClass:"down-load-app",attrs:{"text":_vm.$t('FoodC_Website_The_WEB_pBbW', { pay_name: 'DidiPay' })}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }